import { useQuery } from '@tanstack/react-query';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '@/firebase';
import { Restaurant } from '@/model/entities';

export function useRestaurants() {
  return useQuery<Restaurant[]>({
    queryKey: ['restaurants'],
    queryFn: async () => {
      const snapshot = await getDocs(collection(db, 'restaurants'));
      return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as Restaurant));
    },
    staleTime: 1000 * 60 * 5,
  });
}
